import { render, staticRenderFns } from "./originalBar.vue?vue&type=template&id=44b36359&scoped=true&"
import script from "./originalBar.vue?vue&type=script&lang=js&"
export * from "./originalBar.vue?vue&type=script&lang=js&"
import style0 from "./originalBar.vue?vue&type=style&index=0&id=44b36359&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b36359",
  null
  
)

export default component.exports